import React from 'react';

import './footer.css';

function Footer() {
  
  return (
    <p className='footer'>
      © 2020 Devs_United - 
      <span> BETA </span>
    </p>
  );
}
  
export default Footer;